// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2_daF","paymentContainer":"PaymentPage_paymentContainer__LKNIe"};